const { DateTime } = require('luxon');

/**
 * Validates a value is date that is older than the specified context.
 * @param {any} value The value to validate.
 * @param {any} context Validation context
 * @param {string} context.olderThan A string defining a timespan that the value must be older than.
 * @return {Promise<string | null>} A promise that resolves to an error message, otherwise null
 * @name olderThan
 * @memberof combinators
 */
async function validate(value, context) {
  // always pass on a null input
  if (value === undefined || value === null) {
    return Promise.resolve(null);
  }

  const format = context.format || 'dd/MM/yyyy';
  const { olderThan } = context;

  if (olderThan === undefined) {
    throw new Error('not-older-than');
  }

  const then = DateTime.fromFormat(value, format);

  if (!then.isValid) {
    return Promise.resolve('not-date');
  }

  const now = DateTime.utc();
  const diff = now.diff(then, 'years').toObject().years;

  return Promise.resolve(diff >= olderThan ? null : 'not-older-than');
}

module.exports = validate;
